import React from 'react'
import {connect} from 'react-redux'

import {submitPasswordReset} from '../actions'
import AuthForm from './AuthForm'
import PageWrapper from './PageWrapper'

const ResetPass = props => (
  <AuthForm
    title="Reset password."
    submitText="Reset password"
    showPass
    showPassConfirm
    {...props}
  />
)

const ResetPassPage = PageWrapper(ResetPass)

const mapStateToProps = state => ({
  authError: state.auth.status.reset
})

const mapDispatchToProps = dispatch => ({
  onSubmit: (password, passConfirm) => dispatch(submitPasswordReset(password, passConfirm))
})

const ResetPassWrapper = connect(mapStateToProps, mapDispatchToProps)(ResetPassPage)

export {ResetPassWrapper as default, ResetPass}


// WEBPACK FOOTER //
// ./assets/auth/components/ResetPassPage.js